import React from "react";
import {
    CreateCounterpartyContactBody,
    CounterpartyContact,
} from "@common/schemas/counterpartyContact.schema";
import { StandardModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { CounterpartyContactForm } from "./CounterpartyContactForm";

interface Props {
    show: boolean;
    contact?: CounterpartyContact;
    onSubmit: (body: CreateCounterpartyContactBody) => Promise<void>;
    onHide: () => void;
}

export const CounterpartyContactModal: React.FC<Props> = ({
    show,
    contact,
    onSubmit,
    onHide,
}) => (
    <StandardModal show={show} onHide={onHide} size="md">
        <StandardModalHeader>
            {contact ? "Edit contact" : "Add contact"}
        </StandardModalHeader>
        <CounterpartyContactForm
            key={contact?.id ?? "new"}
            contact={contact}
            submitText={contact ? "Save" : "Add"}
            onSubmit={onSubmit}
            onCancelled={onHide}
        />
    </StandardModal>
);
